import defaultImage from 'static/img/sections/related-notes/default-1.webp';
import fontStyles from 'styles/Fonts.module.scss';
import Image from 'core/image';
import PropTypes from 'prop-types';
import Spacer from 'core/spacer';
import styles from 'styles/BlogContent.module.scss';

const RelatedNote = ({ item }) => {
    return (
        <a className={styles.note} target="_blank" href={item.url} rel="noreferrer">
            <p className={fontStyles.text_normal}>{item.title}</p>
            <div>
                <Image
                    src={item.image || defaultImage}
                    width={200}
                    height={130}
                    alt={item.title}
                    style={{ width: 'auto', height: '100%' }}
                />
            </div>
            <Spacer />
            <small className={fontStyles.text_small}>{item.description}</small>
        </a>
    );
};

RelatedNote.propTypes = {
    item: PropTypes.shape({
        url: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        image: PropTypes.string,
        description: PropTypes.string.isRequired
    })
};

export default RelatedNote;
